require('./bootstrap');

import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import '@/registerServiceWorker';
import '@capacitor/core';

// Router
import router from '@/router/router';

// Vuetify
import vuetify from '@/plugins/vuetify';

// I18n
import i18n from '@/i18n';

// Global Mixin
import GlobalMixin from './mixins/global';
Vue.mixin(GlobalMixin);

Vue.config.productionTip = false;

new Vue({
    components: { App },
    store,
    vuetify,
    i18n,
    router,
    render: h => h(App)
}).$mount('#app');
